import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE} from '../../../../store/search'
import {ActivityStatus, CrudStatus, SearchEntities} from '../../../../common/enums'
import {USER_MODULE_NAMESPACE} from '../../../../store/user/user-types.store'
import {IUserDetails} from '../../../../models/user'
import {BM_EDIT_IB_BY_FIELD, BM_MODULE_NAMESPACE} from '../../../../store/building-monitor/bm-types.store'
import {TICKET_GET_CHARACTER_PROBLEMS, TICKET_MODULE_NAMESPACE} from '../../../../store/ticket'
import {BMIBEditedViewModel} from '../../../../models/bm/bm-ib-edited.viewmodel'
import {IBMDetailViewModel} from '../../../../models/bm'
import {IBMMeetingDetailViewModel} from '../../../../models/bm/bm-meeting-detail.viewmodel'

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
const BMStore = namespace(BM_MODULE_NAMESPACE)
const TicketStore = namespace(TICKET_MODULE_NAMESPACE)

@Component({
// @ts-ignore
  components: { 'v-swatches': async () => import('vue-swatches') }
})
class BMIBModalVertical extends Vue {
  dtRules: {
    participantRules?: any
  }
  dtSearchAllContact: boolean
  dtTemporaryParticipants: any[];
  dtParticipant: any
  dtLoadingIB: boolean
  pmIB: {
    entity: SearchEntities,
    query: string,
    limit: number,
    block: number[]
  }
  swatch: {
    colors: string[],
    style: object
  }
  ibIc: any[]

  constructor () {
    super()
    this.dtRules = {}
    this.dtSearchAllContact = false
    this.dtTemporaryParticipants = []
    this.dtParticipant = null
    this.dtLoadingIB = false
    this.pmIB = {
      entity: SearchEntities.Participant,
      query: '',
      limit: 1000,
      block: []
    }
    this.swatch = {
      colors: [
        '#F92AC2', '#FBCA01', '#A2FF00', '#00F4D9', '#A7A3F9', '#5000FF',
        '#FF0766', '#FF8000', '#00FF17', '#00D195', '#8B86F8', '#2E038C',
        '#FF0000', '#D08442', '#00C812', '#00A072', '#6059F8', '#1B0B37'
      ],
      style: {marginBottom: '12px'}
    }
    this.ibIc = []
  }

  @UserStore.Getter userInfo: IUserDetails;
  @UserStore.Getter isTenantAndOwner: boolean;
  @BMStore.Getter bmCrudActionStatus: CrudStatus
  @BMStore.Getter bmIBEdited: BMIBEditedViewModel
  @TicketStore.Getter characterProblems: any;
  @BMStore.Getter bmSource: { activityStatus: ActivityStatus; detail: IBMDetailViewModel };
  @BMStore.Getter bmMeeting: {
    activityStatus: ActivityStatus;
    data: IBMMeetingDetailViewModel
  };

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    limit?: number,
    entity?: SearchEntities | SearchEntities[],
    block?: number,
    problem?: number
  }) => Promise<any>;
  @TicketStore.Action(TICKET_GET_CHARACTER_PROBLEMS)
  storeGetCharacterProblems: () => void

  @BMStore.Mutation(BM_EDIT_IB_BY_FIELD)
  storeSetBMIBEdited: (payload: { [key: string]: any }) => void

  @Prop({ default: false, type: [Boolean] })
  toUpdate: boolean

  get lblSetting () {
    return {
      ...require('@/locales/ticket').default,
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/generic-labels').default
    }
  }

  get coCharacterProblems (): any[] {
    if (this.characterProblems.level_1.length) {
      const items = this.characterProblems.level_1.filter(x => {
        return this.bmMeeting.data.inspections.findIndex(y => y.fk_character_problem === x.id) === -1
      })
      return [ ...items.slice(1), items[0] ]
    }

    return []
  }

  get IB (): number {
    return this.bmIBEdited.fk_character_problem
  }

  set IB (value) {
    this.storeSetBMIBEdited({fk_character_problem: value})
    if (value) {
      this.storeGetEntitySearch({
        entity: [SearchEntities.IndependentContractor, SearchEntities.CareTaker],
        block: this.bmMeeting.data.master.fk_block,
        problem: value
      }).then(response => {
        this.ibIc = response.map(x => {
          x.selected = true
          return x
        })
        let icSelected = this.ibIc.filter(x => x.selected === true)
        this.Contractor = icSelected.map(x => {
          return {fk_entity_contractor: x.id}
        })
      })
    }
  }

  get Color (): string {
    return '#' + this.bmIBEdited.color
  }

  set Color (value) {
    this.storeSetBMIBEdited({color: value.replace('#', '')})
  }

  get Contractor (): any[] {
    return this.bmIBEdited.contractors
  }

  set Contractor (value) {
    this.storeSetBMIBEdited({contractors: value})
  }

  created () {
    this.dtRules = {
    }
  }

  mounted () {
    this.storeGetCharacterProblems()
    this.$nextTick(() => {
      if (this.toUpdate) {} else {
        this.Color = '#F92AC2'
      }
    })
  }

  changeBundleIC () {
    let icSelected = this.ibIc.filter(x => x.selected === true)
    this.Contractor = icSelected.map(x => {
      return {fk_entity_contractor: x.id}
    })
  }
}

export default BMIBModalVertical



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-ib-modal-vertical/index.ts